import { useApiMutation } from "../../../../../../../core/api/useApiMutation"
import { fetchOneTimeToken } from "../../../../home/weekMenuApi"
import React, { useState, useEffect } from "react"
import { CircularProgress, Box, IconButton, Dialog } from "@mui/material"
import { makeStyles } from "tss-react/mui"
import { CloseTwoTone } from "@mui/icons-material"

type MakePurchaseDialogProps = Readonly<{
    open: boolean
    onClose: () => void
}>

const useStyles = makeStyles()(() => ({
    iframeContainer: {
        position: "relative",
        height: "100%",
        width: "100%",
        overflow: "hidden",
    },
    closeIcon: {
        backgroundColor: "rgba(255, 255, 255, 0.8)",
        position: "absolute",
        top: "1rem",
        right: "1rem",
        zIndex: 1,
    },
    iFrame: {
        border: "none",
        transform: "scale(0.85)",
        transformOrigin: "top left",
        width: "120%",
        height: "120%",
    },
}))

export function MakePurchaseDialog({ open, onClose }: MakePurchaseDialogProps) {
    const { classes } = useStyles()
    const { mutateAsync } = useApiMutation(fetchOneTimeToken, {})
    const [iframeUrl, setIframeUrl] = useState<string | null>(null)
    const [loading, setLoading] = useState<boolean>(false)

    useEffect(() => {
        const fetchTokenAndLoadApp = async () => {
            if (open) {
                setLoading(true)
                setIframeUrl(null)
                try {
                    const resp = await mutateAsync({})
                    setIframeUrl(`https://facilitynet.dk/gopay/login/otp?token=${resp.token}`)
                } finally {
                    setLoading(false)
                }
            }
        }

        fetchTokenAndLoadApp()
    }, [open])

    return (
        <Dialog open={open} onClose={onClose} fullScreen>
            {loading ? (
                <Box display="flex" justifyContent="center" alignItems="center" height="100%">
                    <CircularProgress />
                </Box>
            ) : (
                iframeUrl && (
                    <Box className={classes.iframeContainer}>
                        <IconButton className={classes.closeIcon} onClick={onClose}>
                            <CloseTwoTone />
                        </IconButton>
                        <iframe id="mobile-app" src={iframeUrl} width="100%" height="100%" className={classes.iFrame} />
                    </Box>
                )
            )}
        </Dialog>
    )
}
